
<template>
    <div class="row justify-content-center intro-ct hcol-5">
        <div class="col-11 text-center align-items-center">
            <h1 class="text-yellow">{{$t('welcome_title')}}</h1>
            <h3>{{$t('main_content_text')}}</h3>
            <div class="arrow-down mt-4"></div>
        </div>
    </div>
</template>

<script>
export default {
  components: {
  },
  props: [
  ],
  data () {
    return {
    }
  },
  mounted () {
  },
  created () {
  },
  computed: {
  },
  methods: {
  },
  watch: {
  }
}
</script>

<style scoped lang="scss">
</style>